import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import classNames from 'classnames';
import ClickOutside from 'react-click-outside';
import { ArrowDownIcon, ArrowUpIcon } from '../../components/icons';
import { HorizontalSeparator } from '../../components/separator';
import withCardBackgroundColor from '../../hoc/with-card-background-color';
import withFontClassName from '../../hoc/with-font-class-name';
import styles from './select-desktop.scss';
import { handleEnterKeyUp } from '../../services/accessibility';

const BORDER_WIDTH = 1;

export class SelectDesktop extends Component {
  constructor(props) {
    super(props);

    const { defaultValue } = this.props;
    this.state = {
      value: defaultValue,
      isExpanded: false,
    };
  }

  handleBoxClick = () => {
    this.setState({
      isExpanded: true,
    });
  };

  handleBoxKeyPress = () => {
    this.setState({
      isExpanded: true,
    });
  };

  handleOptionClick = option => {
    if (this.state.value !== option.value) {
      _.invoke(this, 'props.onChange', option.value);
    }
    this.setState({
      value: option.value,
      isExpanded: false,
    });
  };

  handleClickOutside = () => {
    this.setState({ isExpanded: false });
  };

  getSelectedOption() {
    return _.find(this.props.options, option => option.value === this.state.value) || {};
  }

  setElementToFocus = ref => {
    this.elementToFocus = ref;
  };

  componentDidUpdate = () => {
    if (this.elementToFocus) {
      this.elementToFocus.focus();
      this.elementToFocus = undefined;
    }
  };

  renderCollapsed() {
    const { cardBackgroundColor, height, isTransparent } = this.props;
    const containerClassName = classNames(styles.box, 'select-desktop__box', {
      'default-forum-card-background-color': !isTransparent,
    });
    const selectedOption = this.getSelectedOption();
    const style = {
      backgroundColor: isTransparent ? null : cardBackgroundColor,
      height,
    };

    return (
      <div
        className={containerClassName}
        style={style}
        onClick={this.handleBoxClick}
        onKeyUp={handleEnterKeyUp(this.handleBoxKeyPress)}
        tabIndex="0"
      >
        <span className={classNames(styles.label, 'select-desktop__label')}>
          {selectedOption.label}
        </span>
        <ArrowDownIcon className={classNames(styles.arrow, 'forum-icon-fill')}/>
        {isTransparent ? null : <div className={classNames(styles.borders, 'forum-text-border-color')}/>}
      </div>
    );
  }

  renderExpanded() {
    const { cardBackgroundColor, options, height } = this.props;
    const { value } = this.state;
    const selectedOption = this.getSelectedOption();
    const otherOptions = _.filter(options, option => option.value !== value);
    const items = _.map([selectedOption, ...otherOptions], (option, index) => {
      const isFirst = index === 0;
      const containerClassName = classNames(styles.option, 'select-desktop__option', {
        'button-color': isFirst,
      });
      const style = { height: height - BORDER_WIDTH };
      const handleOptionClick = () => this.handleOptionClick(option);

      return (
        <div
          ref={isFirst && this.setElementToFocus}
          className={containerClassName}
          key={option.value}
          onClick={handleOptionClick}
          onKeyUp={handleEnterKeyUp(handleOptionClick)}
          tabIndex="0"
          data-hook="listbox-option"
        >
          <div className={styles.optionWrapper} style={style}>
            <div className={classNames(styles.hoverBackground, 'forum-text-background-color')}/>
            <div className={styles.optionContent}>
              <span className={styles.label}>
                {option.label}
              </span>
              <ArrowUpIcon className={classNames(styles.arrow, 'forum-icon-fill')}/>
            </div>
          </div>
          <div className={styles.separator}>
            <HorizontalSeparator/>
          </div>
        </div>
      );
    });

    const overlayClassName = classNames(styles.overlay, 'default-forum-card-background-color');
    return (
      <ClickOutside onClickOutside={this.handleClickOutside}>
        <div className={overlayClassName} style={{ backgroundColor: cardBackgroundColor }}>
          <div className={styles.scrollable}>
            {items}
          </div>
          <div className={classNames(styles.borders, 'forum-text-border-color')}/>
        </div>
      </ClickOutside>
    );
  }

  render() {
    const { className, contentFontClassName, height, isScrollable } = this.props;
    const containerClassName = classNames(styles.container, contentFontClassName, className, 'forum-text-color', {
      [styles.isScrollable]: isScrollable,
    });
    const { isExpanded } = this.state;
    const style = { height };
    return (
      <div className={containerClassName} style={style} role="listbox" data-hook="listbox">
        {isExpanded ? this.renderExpanded() : this.renderCollapsed()}
      </div>
    );
  }
}

SelectDesktop.propTypes = {
  className: PropTypes.string,
  cardBackgroundColor: PropTypes.string.isRequired,
  contentFontClassName: PropTypes.string.isRequired,
  defaultValue: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  height: PropTypes.number,
  isTransparent: PropTypes.bool,
  isScrollable: PropTypes.bool,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.any.isRequired,
    })
  ),
};

SelectDesktop.defaultProps = {
  isScrollable: true,
};

export default _.flowRight(withCardBackgroundColor, withFontClassName)(SelectDesktop);



// WEBPACK FOOTER //
// ./app/components/select/select-desktop.js